document.addEventListener("DOMContentLoaded", () => {

  const feelButtons = document.querySelectorAll(".feel-btn");
  const feelTitle = document.getElementById("selectedFeel");
  const feelDescription = document.getElementById("feelDescription");

  if (!feelButtons.length) return;

  feelButtons.forEach(btn => {
    btn.addEventListener("click", function () {

      feelButtons.forEach(b => b.classList.remove("active"));

      this.classList.add("active");

      feelTitle.textContent = this.dataset.title;

      feelDescription.textContent =
        this.dataset.description;

    });

  });

});

function updateAvailableDimensions() {
  const size = selected[0];
  const thickness = selected[1];

  const variants = window.productVariants || [];

  const validVariants = variants.filter(v => {
    return (!size || v.options[0] === size) &&
           (!thickness || v.options[1] === thickness);
  });

  const validDimensions = [...new Set(validVariants.map(v => v.options[2]))];

  const container = document.getElementById("optionGroup2");
  if (!container) return;

  container.innerHTML = validDimensions.map(dim => `
    <button type="button" class="opt-btn" onclick="selectOption(2,'${dim}', this)">
     ${formatDimensionButton(dim)}
           
    </button>
  `).join("");
      //   ${dim}

  // Auto select first dimension
  const firstBtn = container.querySelector(".opt-btn");

  if (firstBtn) {
    firstBtn.click();
  } else {
    delete selected[2];

    const label = document.getElementById("selectedDimensions");
    if (label) label.innerText = "None";
  }
}
/* =========================
   STATE
========================= */
let selected = {};

/* =========================
   SELECT OPTION (size / thickness / dimensions)
========================= */
function selectOption(index, value, btn) {
  selected[index] = value;

  // label update
  if (index === 0) {
    const el = document.getElementById("selectedSize");
    if (el) el.innerText = value;
  } else if (index === 1) {
    const el = document.getElementById("selectedThickness");
    if (el) el.innerText = value;
  } else if (index === 2) {
    const el = document.getElementById("selectedDimensions");
    // if (el) el.innerText = value;
    if (el) el.innerText = formatDimension(value);
  }

  // active class — only within that option group
  const group = document.getElementById("optionGroup" + index);
  if (group) {
    group.querySelectorAll(".opt-btn").forEach(b => b.classList.remove("active"));
  }
  if (btn) btn.classList.add("active");

  updateVariant();
   // 🔥 ADD THIS
  if (index === 0 || index === 1) {
    updateAvailableDimensions();
  }
}

/* =========================
   UPDATE VARIANT
========================= */
function updateVariant() {
  const variants = window.productVariants || [];

  const variant = variants.find(v => {
    return Object.entries(selected).every(([i, val]) => {
      return v.options[parseInt(i)] === val;
    });
  });

  if (!variant) return;

  // variant id
  const vidEl = document.getElementById("variantId");
  if (vidEl) vidEl.value = variant.id;

  // price
  const priceEl = document.getElementById("price");
  const mrpEl   = document.getElementById("mrp");
  const atcEl   = document.getElementById("atcBtn");
  const saveEl  = document.getElementById("saveText");

  if (priceEl) priceEl.innerText = formatMoney(variant.price);

  if (mrpEl && variant.compare_at_price) {
    mrpEl.innerText = "MRP " + formatMoney(variant.compare_at_price);
  }

  if (atcEl) {
    atcEl.innerText = "Add to Cart — " + formatMoney(variant.price);
  }

  if (saveEl && variant.compare_at_price && variant.compare_at_price > variant.price) {
    const saved = variant.compare_at_price - variant.price;
    const pct   = Math.round((saved / variant.compare_at_price) * 100);
    saveEl.innerText = "Save " + formatMoney(saved) + " · " + pct + "% off";
  }
}

/* =========================
   IMAGE SWITCH
========================= */
function changeImage(el, src, index) {
  const main = document.getElementById("MainImage");
  const idx  = document.getElementById("imgIndex");

  if (main) main.src = src;
  if (idx)  idx.innerText = index < 10 ? "0" + index : index;

  document.querySelectorAll(".gallery__thumbs img")
    .forEach(img => img.classList.remove("active"));
  el.classList.add("active");
}

/* =========================
   QUANTITY
========================= */
function qtyChange(val) {
  const input = document.getElementById("qty");
  if (!input) return;
  let qty = parseInt(input.value) + val;
  if (qty < 1) qty = 1;
  input.value = qty;
}

/* =========================
   MONEY FORMAT
========================= */
function formatMoney(cents) {
  return "₹" + Math.round(cents / 100).toLocaleString("en-IN");
}
function formatDimension(value) {
  if (!value) return "";

  // Example:
  // 78*36 (198.12cm*91.4cm) (6.5ft*3ft)

  const match = value.match(/^(\d+)\*(\d+)\s*\((.*?)\)\s*\((.*?)\)$/);

  if (!match) return value;

  const inch = `${match[1]}*${match[2]} inches`;

  const cm = match[3]
    .replace(/\*/g, " × ")
    .replace(/cm/gi, " CM");

  const ft = match[4]
    .replace(/\*/g, " × ");

  return `${inch} / ${cm} / ${ft}`;
  
}

function formatDimensionButton(value) {
  // Example input:
  // 72*60 (182.88cm*152.4cm) (6ft*5ft)

  const match = value.match(/^(\d+\*\d+)\s*\((.*?)\)\s*\((.*?)\)$/);

  if (!match) {
    return `
      <span class="dim-ft">${value}</span>
    `;
  }

  const inches = match[1].replace(/\*/g, " × ") + " inches";
  const cm = match[2].replace(/cm/gi, " CM").replace(/\*/g, " × ");
  const ft = match[3].replace(/\*/g, " × ");

  return `
  <span class="dim-inches">${inches}</span>
   
  `;
}
// version-1
  // <span class="dim-inches">${inches}</span>
  //   <span class="dim-cm">${cm}</span>
  //   <span class="dim-ft">${ft}</span>
// version-2
  // <span class="dimension">
  //   ${inches} / ${cm} / ${ft}
  // </span>
/* =========================
   DELIVERY DATE (TODAY + 7 DAYS)
========================= */
function setDeliveryDate() {
  const el = document.getElementById("delivery-date");
  if (!el) return;

  const today = new Date();
  const delivery = new Date();
  delivery.setDate(today.getDate() + 7);

  const options = {
    weekday: "short",
    day: "2-digit",
    month: "short"
  };

  el.innerText = delivery.toLocaleDateString("en-US", options);
}

/* =========================
   COUNTDOWN TIMER
========================= */
function startCountdown() {
  const el = document.getElementById("countdown");
  if (!el) return;

  let parts = el.innerText.split(":").map(Number);
  let total = parts[0] * 3600 + parts[1] * 60 + parts[2];

  const tick = setInterval(() => {
    if (total <= 0) { clearInterval(tick); return; }
    total--;
    const h = String(Math.floor(total / 3600)).padStart(2, "0");
    const m = String(Math.floor((total % 3600) / 60)).padStart(2, "0");
    const s = String(total % 60).padStart(2, "0");
    el.innerText = `${h}:${m}:${s}`;
  }, 1000);
}

/* =========================
   DOM READY
========================= */
document.addEventListener("DOMContentLoaded", () => {

  // wishlist toggle
  const wishlistBtn = document.getElementById("wishlistBtn");
  if (wishlistBtn) {
    wishlistBtn.addEventListener("click", () => {
      wishlistBtn.classList.toggle("active");
      wishlistBtn.innerText = wishlistBtn.classList.contains("active") ? "♥" : "♡";
    });
  }

  // delivery date + countdown
  setDeliveryDate();
  startCountdown();

  // pincode check
  const pincodeBtn = document.getElementById("pincodeCheckBtn");
  const pincodeField = document.getElementById("pincodeField");
  if (pincodeBtn && pincodeField) {
    pincodeBtn.addEventListener("click", () => {
      const pin = pincodeField.value.trim();
      const statusText = document.querySelector(".pincode-status__text");
      if (pin.length === 6 && /^\d+$/.test(pin)) {
        if (statusText) statusText.innerText = `Delivery available to ${pin} · 3-6 days`;
      } else {
        if (statusText) statusText.innerText = "Please enter a valid 6-digit pincode";
      }
    });
  }

  // auto-select first button of each option group (0, 1, 2)
  // [0, 1, 2].forEach(index => {
  //   const group = document.getElementById("optionGroup" + index);
  //   if (group) {
  //     const firstBtn = group.querySelector(".opt-btn");
  //     if (firstBtn) firstBtn.click();
  //   }
  // });

  // Default Selection
// Size -> badge wala
const sizeGroup = document.getElementById("optionGroup0");
if (sizeGroup) {
  const defaultSize =
    sizeGroup.querySelector(".option-badge")?.closest(".opt-btn") ||
    sizeGroup.querySelector(".opt-btn");

  if (defaultSize) defaultSize.click();
}

// Thickness -> badge wala
const thicknessGroup = document.getElementById("optionGroup1");
if (thicknessGroup) {
  const defaultThickness =
    thicknessGroup.querySelector(".option-badge")?.closest(".opt-btn") ||
    thicknessGroup.querySelector(".opt-btn");

  if (defaultThickness) defaultThickness.click();
}

// Dimensions -> first available
const dimGroup = document.getElementById("optionGroup2");
if (dimGroup) {
  const firstDim = dimGroup.querySelector(".opt-btn");
  if (firstDim) firstDim.click();
}
});

/* =========================
   AJAX ADD TO CART + CART DRAWER
========================= */

document.addEventListener("DOMContentLoaded", () => {

  const productForm = document.getElementById("productForm");
  const atcBtn = document.getElementById("atcBtn");

  if (!productForm || !atcBtn) return;

  productForm.addEventListener("submit", async function(e) {

    e.preventDefault();

    const variantId = document.getElementById("variantId")?.value;
    const quantity = document.getElementById("qty")?.value || 1;

    if (!variantId) {
      alert("Please select variant");
      return;
    }

    atcBtn.disabled = true;
    atcBtn.innerText = "Adding...";

    try {

      const response = await fetch("/cart/add.js", {

        method: "POST",

        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },

        body: JSON.stringify({

          id: variantId,
          quantity: Number(quantity),

          sections: "cart-drawer,cart-icon-bubble"

        })

      });

      const state = await response.json();

      console.log("Added Product:", state);


      /*
        Cart Drawer Update
      */

      const cartDrawer = document.querySelector("cart-drawer");

      if (cartDrawer && state.sections) {

        cartDrawer.renderContents(state);

      }


      atcBtn.disabled = false;

      atcBtn.innerText =
        "Add to Cart — " + formatMoney(state.price);


    } catch(error) {

      console.error("ATC Error:", error);

      atcBtn.disabled = false;

      atcBtn.innerText = "Add to Cart";

    }

  });

});

/* =========================
   BUY NOW
========================= */

document.addEventListener("DOMContentLoaded", () => {

  const buyNowBtn = document.getElementsByClassName("buy-nohuihw")[0];
  if (!buyNowBtn) return;

  buyNowBtn.addEventListener("click", async () => {

    const variantId = document.getElementById("variantId")?.value;
    const quantity = Number(document.getElementById("qty")?.value || 1);

    if (!variantId) {
      alert("Please select a variant");
      return;
    }

    buyNowBtn.disabled = true;
    buyNowBtn.innerText = "Redirecting...";

    try {

      await fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "Accept": "application/json"
        }
      });

      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });

      window.location.href = "/checkout";

    } catch (err) {

      console.error(err);

      buyNowBtn.disabled = false;
      buyNowBtn.innerHTML = '<span class="buy-icon">⚡</span> Buy Now Express';

    }

  });

});